import React from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import "./pickles.css";
import Img1 from "./img1.png";
import Img2 from "./img2.png";
import Img3 from "./img3.png";
import Img4 from "./img4.png";
// import Pickles from "./img4.png";
// import Img3 from "../home/img2.png";
import SingleRecipiePage from "../../components/singleRecipiePage/SingleRecipiePage";
import SingleRecipiePageRight from "../../components/singleRecipiePage/SingleRecipiePageRight";
import EcavowhiteComponent from "../../components/ecavowhiteComponent/EcavowhiteComponent";

const Pickles = () => {
  return (
    <>
      <Navb />
      <div className="whiteComponentsingleEcavo picklesbg1">
        <SingleRecipiePage
          currrentImg={Img1}
          heading="NANDI Lal Mirch Aachar"
          text="Savor a spoonful of Nandi's flavorful Bharwa Lal Mirch Anchar. Delight in the rich bites of red chillies, expertly combined with selected spices, and relish the unique tingling taste that lasts throughout the year."
          headingcss="whiteHeading"
          pcss="whiteP"
          // link1="link"
          // link1Text="View Recipes"
          link2="https://ecavo.shop/products/bharwa-red-chili-pickle"
          linkClass="whiteButton"
          //   sideImg={Sideimg1}
        />
      </div>
      <div className="whiteComponentsingleEcavoRight picklesbg2">
        <SingleRecipiePageRight
          currrentImg={Img2}
          heading="NANDI Green Chilli Aachar"
          text="Indulge in a spoonful of Nandi's flavourful Green Chillies Aachar. Sink your teeth into succulent pieces of green chillies, expertly blended with selected spices, and relish the distinctive tingling taste that lasts throughout the year."
          headingcss="whiteHeading"
          pcss="whiteP"
          // link1="link"
          // link1Text="View Recipes"
          link2="https://ecavo.shop/products/mirchi-pickle"
          linkClass="whiteButton"
          //   sideImg={Sideimg1}
        />
      </div>
      <div className="whiteComponentsingleEcavo picklesbg3">
        <SingleRecipiePage
          currrentImg={Img3}
          heading="NANDI Aam Aachar"
          text="Savor a spoonful of Nandi's flavorful Bharwa Lal Mirch Anchar. Delight in the rich bites of red chillies, expertly combined with selected spices, and relish the unique tingling taste that lasts throughout the year."
          headingcss="blackHeading"
          pcss="blackP"
          // link1="link"
          // link1Text="View Recipes"
          link2="https://ecavo.shop/products/mango-pickle"
          linkClass="blackButton"
          //   sideImg={Sideimg1}
        />
      </div>
      <div className="whiteComponentsingleEcavoRight picklesbg1">
        <SingleRecipiePageRight
          currrentImg={Img3}
          heading="NANDI Mixed Aachar"
          text="Indulge in a spoonful of Nandi's delightful Mixed Aachar. Savor the delightful blend of mango, carrots, chillies, garlic, ginger, lemon, and more, combined with carefully chosen spices, for a daily burst of spicy tingling goodness."
          headingcss="whiteHeading"
          pcss="whiteP"
          // link1="link"
          // link1Text="View Recipes"
          link2="https://ecavo.shop/products/mix-pickle"
          linkClass="whiteButton"
          //   sideImg={Sideimg1}
        />
      </div>
      

      <Footer />
    </>
  );
};

export default Pickles;
